(function() {
    'use strict';
  
    /**
     * Mega menu: show on hover, stay open when moving to dropdown so user can click links.
     * Delay close on mouseleave so moving from nav item to fixed-position dropdown doesn't close it.
     */
    function initMeganavHover() {
      const triggers = document.querySelectorAll('.navmenu-item[data-navmenu-meganav-trigger], .header .main-menu > li[data-navmenu-meganav-trigger]');
      let closeTimeout = null;

      function closeAllExcept(detailsToKeep) {
        document.querySelectorAll('.navmenu-item[data-navmenu-meganav-trigger] details, .header .main-menu > li[data-navmenu-meganav-trigger] details').forEach((d) => {
          if (d !== detailsToKeep) d.removeAttribute('open');
        });
      }

      triggers.forEach((trigger) => {
        const details = trigger.querySelector('details');
        const summary = trigger.querySelector('summary');
        if (!details || !summary) return;

        summary.addEventListener('click', function(e) {
          e.preventDefault();
        });

        trigger.addEventListener('mouseenter', function() {
          if (closeTimeout) {
            clearTimeout(closeTimeout);
            closeTimeout = null;
          }
          closeAllExcept(details);
          details.setAttribute('open', '');
        });

        trigger.addEventListener('mouseleave', function(e) {
          var related = e.relatedTarget;
          if (related && trigger.contains(related)) return;
          closeTimeout = setTimeout(function() {
            details.removeAttribute('open');
            closeTimeout = null;
          }, 300);
        });
      });

      document.addEventListener('mouseover', function(e) {
        if (e.target.closest && e.target.closest('.second-level-menu') && closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
      }, true);

      window.addEventListener('scroll', function() {
        if (closeTimeout) clearTimeout(closeTimeout);
        closeTimeout = null;
        document.querySelectorAll('.navmenu-item[data-navmenu-meganav-trigger] details[open], .header .main-menu > li[data-navmenu-meganav-trigger] details[open]').forEach(function(d) {
          d.removeAttribute('open');
        });
      }, { passive: true });
    }

    /**
     * Third-level links are now inline under each second-level column; no overlay/back needed.
     */

    // Initialize on DOM ready
    function init() {
      initMeganavHover();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  